/* The Food Arcade (Nov 2 2026): /pages/food-arcade. Three short daily games, no account needed.
   - The day is the Arizona date; a new set starts at midnight Arizona time (07:00 UTC). Everyone gets the same games.
   - Rot or Not?: each round shows the Fresh Market pick and skip photos of one item side by
     side; tap the fresh one. The LIVE assets/vg-fresh-images.js is read first, so remade photos
     show up by themselves; vg-food-arcade-data.json holds a fallback copy.
   - Guess the Grocery Price: PRICES ARE READ LIVE from vg-pricing-summary.json (the Pricing Guide's nightly file):
     U.S. typical unit price x package size x size ratio, the same formula as BakeBudget. Store prices are only ever
     credited to "National Grocery Chain" stores.
   - Recipe Detective: ingredient clues from a published recipe; the answer links to it.
   - Progress stays in this browser (localStorage vg_food_arcade_v1). No accounts, prizes, leaderboards or analytics
     events. Shared results never show answers. */
(function () {
  'use strict';
  var root = document.querySelector('[data-vg-fa]');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var KEY = 'vg_food_arcade_v1', CHAIN = 'National Grocery Chain', PAGE = '/pages/food-arcade';
  var ROT_N = 6, PRICE_N = 5, DET_START = 2;
  var NAMES = { rot: 'Rot or Not?', price: 'Guess the Grocery Price', det: 'Recipe Detective' };
  var ORDER = ['rot', 'price', 'det'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var D = null, P = { idx: {}, failed: 0 }, FRESH = null, S = null, today = '', dayN = 0, active = '', sets = {};
  var stage = root.querySelector('[data-stage]');

  /* ---------- helpers ---------- */
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) { return '$' + (Math.round(v * 100) / 100).toFixed(2); }
  function cap1(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function rng(seed) {   // mulberry32: the same sequence for everyone on the same day
    var a = seed >>> 0;
    return function () { a = (a + 0x6D2B79F5) >>> 0; var t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }
  function shuffle(arr, r) { var a = arr.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(r() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function getJSON(url) { return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function azKey(ms) { return new Date(ms - 7 * 3600e3).toISOString().slice(0, 10); }
  function prettyDay(key) { var p = key.split('-'); return MONTHS[+p[1] - 1].slice(0, 3) + ' ' + (+p[2]) + ', ' + p[0]; }
  function monthLabel(per) { var p = /^(\d{4})-(\d{2})$/.exec(per || ''); return p ? MONTHS[+p[2] - 1] + ' ' + p[1] : 'this month'; }

  /* ---------- saved progress (this browser only) ---------- */
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { s = null; }
    if (!s || s.v !== 1 || typeof s.d !== 'object') s = { v: 1, d: {}, tot: { pts: 0, games: 0 } };
    s.tot = s.tot || { pts: 0, games: 0 };
    return s;
  }
  function save() {
    var keys = Object.keys(S.d).sort();
    while (keys.length > 60) delete S.d[keys.shift()];
    try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) { /* storage blocked: the game still plays */ }
  }
  function day() { return S.d[today] || (S.d[today] = {}); }
  function finish(game, pts) {
    var g = day()[game];
    if (g.done) return;
    g.done = 1; g.pts = pts;
    S.tot.pts += pts; S.tot.games += 1;
    save();
  }
  function streak() {
    var n = 0, t = Date.parse(today + 'T12:00:00Z'), k = today;
    function played(key) { var d = S.d[key]; return !!(d && ORDER.some(function (g) { return d[g] && d[g].done; })); }
    if (!played(k)) { t -= 864e5; k = new Date(t).toISOString().slice(0, 10); }
    while (played(k)) { n++; t -= 864e5; k = new Date(t).toISOString().slice(0, 10); }
    return n;
  }

  /* ---------- data ---------- */
  function indexPrices(s) {
    var idx = {};
    (s.observations || []).forEach(function (o) {
      if (o.tier !== 'retail' || !(o.price > 0) || o.geography_type !== 'national' || !/^vg_(?:st|kr)/.test(o.comparison_method || '')) return;
      if (!idx[o.ingredient_id] || o.period > idx[o.ingredient_id].period) idx[o.ingredient_id] = o;
    });
    return { idx: idx };
  }
  function loadFresh(url) {
    return new Promise(function (ok) {
      if (window.VG_FRESH_IMAGES) { ok(window.VG_FRESH_IMAGES); return; }
      if (!url) { ok(null); return; }
      var s = document.createElement('script');
      s.src = url; s.async = true;
      s.onload = function () { ok(window.VG_FRESH_IMAGES || null); };
      s.onerror = function () { ok(null); };
      document.head.appendChild(s);
      setTimeout(function () { ok(window.VG_FRESH_IMAGES || null); }, 6000);
    });
  }
  function pic(entry, fallback) {   // [url, description]
    if (entry && entry.url) return [entry.url, String(entry.alt || '').split(':').slice(1).join(':').trim() || fallback[1]];
    return fallback;
  }

  /* ---------- today's sets ---------- */
  function buildSets() {
    var r, L, i;
    // Rot or Not?: six items, each a fresh photo and a rotten one side by side (the fresh side is random)
    L = D.rot.length;
    sets.rot = [];
    for (i = 0; i < ROT_N && L; i++) {
      var it = D.rot[(dayN * ROT_N + i) % L], live = FRESH && FRESH[it.h];
      sets.rot.push({ it: it, hot: pic(live && live.pick, it.p), rot: pic(live && live.skip, it.s), left: rng(dayN * 7919 + 13 + i)() < 0.5 ? 'hot' : 'rot' });
    }
    // Recipe Detective: one recipe a day, four choices
    if (D.det.length) {
      var c = D.det[dayN % D.det.length];
      r = rng(dayN * 31 + 7);
      sets.det = { c: c, opts: shuffle([c.t].concat(c.o), r) };
    }
  }
  function buildPrice() {   // Guess the Grocery Price: five items that have a live U.S. store price today
    var L = D.price.length, i, out = [];
    for (i = 0; i < L && out.length < PRICE_N; i++) {
      var p = D.price[(dayN * PRICE_N + i) % L], o = P.idx[p.id];
      if (!o) continue;
      var k = p.sz * p.r, sp = o.store_spread || null;
      out.push({ it: p, a: Math.round(o.price * k * 100) / 100, per: o.period, stores: o.store_count || 0,
        lo: sp && sp.p25 ? Math.round(sp.p25 * k * 100) / 100 : 0, hi: sp && sp.p75 ? Math.round(sp.p75 * k * 100) / 100 : 0 });
    }
    sets.price = out;
  }

  /* ---------- board ---------- */
  function stateText(game) {
    var g = day()[game];
    if (game === 'rot' && g && g.done) return g.pts + '/' + ROT_N;
    if (g && g.done) return g.pts + ' pts';
    if (g && ((g.a && g.a.length) || (g.g && g.g.length) || g.shown > DET_START || (g.wrong && g.wrong.length))) return 'Continue';
    return 'Play';
  }
  function drawBoard() {
    var d = day(), n = 0;
    ORDER.forEach(function (g) {
      var el = $('[data-state="' + g + '"]'), tile = $('[data-open="' + g + '"]');
      if (el) el.textContent = stateText(g);
      if (tile) { tile.classList.toggle('is-done', !!(d[g] && d[g].done)); tile.setAttribute('aria-pressed', active === g ? 'true' : 'false'); }
      if (d[g] && d[g].done) n++;
    });
    $('[data-stat-today]').textContent = n;
    $('[data-stat-streak]').textContent = streak();
    $('[data-stat-points]').textContent = S.tot.pts;
    var all = $('[data-alldone]');
    all.hidden = n < 3;
    if (n >= 3) {
      $('[data-alldone-text]').textContent = 'Rot or Not? ' + d.rot.pts + '/' + ROT_N + ', Grocery Price ' + d.price.pts + ' points, Recipe Detective ' +
        d.det.pts + ' points. Come back tomorrow for a new set.';
    }
  }
  function open(game, scroll) {
    if (game === 'price' && !sets.price && !P.failed) {   // the price file is large, so it loads after the other games
      active = game; drawBoard();
      stage.innerHTML = '<p class="vgfa-loading">Loading this month\'s prices\u2026</p>';
      if (scroll) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (!sets[game] || (game !== 'det' && !sets[game].length)) {
      stage.innerHTML = '<p class="vgfa-loading">' + esc(NAMES[game]) + " isn't available right now. Please try again later.</p>";
      return;
    }
    active = game;
    ({ rot: drawRot, price: drawPrice, det: drawDet })[game]();
    drawBoard();
    if (scroll) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function nextGame() {
    for (var i = 0; i < ORDER.length; i++) { var g = day()[ORDER[i]]; if (!(g && g.done)) return ORDER[i]; }
    return '';
  }
  function footer(game) {
    var nx = nextGame();
    return '<div class="vgfa-row">' +
      '<button type="button" class="vgfa-btn" data-share="' + game + '">Share my score</button>' +
      (nx ? '<button type="button" class="vgfa-btn vgfa-btn--solid" data-go="' + nx + '">Next: ' + esc(NAMES[nx]) + '</button>' : '') +
      '</div><p class="vgfa-small">Sharing never shows the answers.</p>';
  }
  function head(game, sub) {
    return '<div class="vgfa-ghead"><span class="vgfa-over">' + esc(NAMES[game]) + '</span><span class="vgfa-sub">' + sub + '</span></div>';
  }
  function dots(total, results, cur) {
    var h = '<ol class="vgfa-dots" aria-hidden="true">';
    for (var i = 0; i < total; i++) {
      var c = i < results.length ? (results[i] ? 'ok' : 'no') : (i === cur ? 'cur' : '');
      h += '<li class="' + c + '"></li>';
    }
    return h + '</ol>';
  }

  /* ---------- Rot or Not? ---------- */
  var HOT_LINES = ['Not rot! That one\'s a keeper.', 'Fresh pick. Your basket thanks you.', 'Not rot! Good eye.',
    'Not rot! Farmers market material.', 'Fresh and fabulous. Nice pick.', 'Not rot! You know your produce.'];
  var ROT_LINES = ['Rot! That one\'s seen better days.', 'Oof, that one\'s past its prime.', 'Rot! That was the tired one.',
    'Rot! The other one was fresher.', 'Rot! Better luck next round.', 'Rot! That one has had a long week.'];
  function rotCard(x, side, n, picked, reveal) {
    var img = x[side], hot = side === 'hot', cls = 'vgfa-rotcard', ab = side === x.left ? 'A' : 'B';
    if (reveal) cls += hot ? ' is-hot' : ' is-rot';
    if (picked === side) cls += ' is-picked';
    var inner = '<img src="' + esc(sized(img[0], 600)) + '" alt="' + esc(x.it.n + ', photo ' + ab) + '" width="600" height="600"' + (n ? ' loading="lazy"' : '') + '>' +
      (reveal ? '<span class="vgfa-rotbadge">' + (hot ? 'NOT ROT' : 'ROT') + '</span>' : '') +
      (reveal && picked === side ? '<span class="vgfa-rotyou">Your pick</span>' : '');
    return reveal ? '<figure class="' + cls + '">' + inner + '</figure>'
      : '<button type="button" class="' + cls + '" data-rot="' + side + '">' + inner + '</button>';
  }
  function drawRot(feedback) {
    var g = day().rot || (day().rot = { a: [] }), set = sets.rot, i = g.a.length;
    if (!g.t) g.t = [];
    if (i >= set.length && !feedback) {
      var right = g.a.filter(Boolean).length;
      if (!g.done) finish('rot', right);
      stage.innerHTML = '<article class="vgfa-game">' + head('rot', 'Done for today') +
        '<div class="vgfa-score"><strong>' + right + '/' + set.length + '</strong><span>' +
        (right === set.length ? 'No rot in sight. A perfect basket.' : right >= set.length - 2 ? 'Sharp eye.' : 'Tomorrow brings six new matchups.') + '</span></div>' +
        dots(set.length, g.a, -1) +
        '<ul class="vgfa-recap">' + set.map(function (x, k) {
          return '<li><img src="' + esc(sized(x.hot[0], 160)) + '" alt="" width="56" height="56" loading="lazy">' +
            '<span><b>' + esc(x.it.n) + '</b> <em class="' + (g.a[k] ? 'ok' : 'no') + '">' + (g.a[k] ? 'picked the fresh one' : 'picked the rot') + '</em></span>' +
            '<a href="/pages/ingredients/' + encodeURIComponent(x.it.h) + '">How to pick ' + esc(x.it.n.toLowerCase()) + '</a></li>';
        }).join('') + '</ul>' + safetyLine() + footer('rot') + '</article>';
      return;
    }
    var n = feedback ? i - 1 : i, x = set[n], h, sidesLR = [x.left, x.left === 'hot' ? 'rot' : 'hot'];
    h = '<article class="vgfa-game">' + head('rot', 'Round ' + (n + 1) + ' of ' + set.length) + dots(set.length, g.a, n) +
      '<h2 class="vgfa-q">' + esc(x.it.n) + '</h2>';
    if (!feedback) {
      h += '<p class="vgfa-help"><b>Rot or Not?</b> Tap the fresh one.</p>' +
        '<div class="vgfa-rotpair">' + rotCard(x, sidesLR[0], n, '', false) + '<span class="vgfa-rotvs" aria-hidden="true">vs</span>' + rotCard(x, sidesLR[1], n, '', false) + '</div>' +
        safetyLine();
    } else {
      var ok = g.a[n], picked = g.t[n] || (ok ? 'hot' : 'rot');
      h += '<div class="vgfa-rotpair">' + rotCard(x, sidesLR[0], n, picked, true) + '<span class="vgfa-rotvs" aria-hidden="true">vs</span>' + rotCard(x, sidesLR[1], n, picked, true) + '</div>' +
        '<div class="vgfa-feedback ' + (ok ? 'ok' : 'no') + '" role="status"><strong>' + esc((ok ? HOT_LINES : ROT_LINES)[n % 6]) + '</strong>' +
        '<p><b>The fresh one:</b> ' + esc(cap1(x.hot[1])) + '. <b>Look for:</b> ' + esc(x.it.look) + '. <b>Feel:</b> ' + esc(x.it.feel) + '.</p>' +
        '<p><b>The other one:</b> ' + esc(cap1(x.rot[1])) + '. <b>Skip at the store:</b> ' + esc(x.it.avoid) + '.</p>' +
        '<a href="/pages/ingredients/' + encodeURIComponent(x.it.h) + '">How to pick ' + esc(x.it.n.toLowerCase()) + '</a></div>' +
        '<div class="vgfa-row"><button type="button" class="vgfa-btn vgfa-btn--solid" data-rot-next>' + (i >= set.length ? 'See my score' : 'Next round') + '</button></div>';
    }
    stage.innerHTML = h + '</article>';
  }
  function safetyLine() {
    return '<p class="vgfa-note">Looks tell you about quality, not safety. <a href="#looks-and-safety">Why that matters</a></p>';
  }

  /* ---------- Guess the Grocery Price ---------- */
  var SL_MAX = 40;
  function toSlider(v) { return Math.round(Math.sqrt(Math.max(0, Math.min(SL_MAX, v)) / SL_MAX) * 1000); }
  function fromSlider(s) { var v = SL_MAX * Math.pow(s / 1000, 2); return v < 10 ? Math.round(v * 20) / 20 : Math.round(v * 4) / 4; }
  function pricePts(g, a) { var e = Math.abs(g - a) / a; return e <= 0.05 ? 100 : Math.max(0, Math.round(100 * (1 - (e - 0.05) / 0.45))); }
  function drawPrice(feedback) {
    var g = day().price || (day().price = { g: [] }), set = sets.price, i = g.g.length;
    if (i >= set.length && !feedback) {
      var tot = g.g.reduce(function (t, r) { return t + r.p; }, 0);
      if (!g.done) finish('price', tot);
      stage.innerHTML = '<article class="vgfa-game">' + head('price', 'Done for today') +
        '<div class="vgfa-score"><strong>' + tot + '</strong><span>points out of ' + (set.length * 100) + '</span></div>' +
        '<ul class="vgfa-recap">' + set.map(function (x, k) {
          var r = g.g[k];
          return '<li><img src="' + esc(sized(x.it.pic, 160)) + '" alt="" width="56" height="56" loading="lazy">' +
            '<span><b>' + esc(x.it.n) + ', ' + esc(x.it.l) + '</b> typical ' + money(r.a) + ', you said ' + money(r.v) + ' <em class="' + (r.p >= 70 ? 'ok' : 'no') + '">+' + r.p + '</em></span>' +
            '<a href="/pages/check-a-price?item=' + encodeURIComponent(x.it.id) + '">Check this price</a></li>';
        }).join('') + '</ul>' +
        '<p class="vgfa-small">Typical regular shelf prices at ' + CHAIN + ' stores across the U.S., ' + esc(monthLabel(set[0].per)) + '.</p>' +
        footer('price') + '</article>';
      return;
    }
    var n = feedback ? i - 1 : i, x = set[n], h;
    h = '<article class="vgfa-game">' + head('price', 'Item ' + (n + 1) + ' of ' + set.length) + dots(set.length, g.g.map(function (r) { return r.p >= 70; }), n) +
      '<div class="vgfa-item"><img src="' + esc(sized(x.it.pic, 240)) + '" alt="" width="96" height="96">' +
      '<div><h2 class="vgfa-q">' + esc(x.it.n) + '</h2><p class="vgfa-size">' + esc(x.it.l) + '</p></div></div>';
    if (!feedback) {
      h += '<p class="vgfa-help">What is the typical shelf price at ' + CHAIN + ' stores across the U.S. this month?</p>' +
        '<div class="vgfa-guess"><label class="vgfa-money"><span aria-hidden="true">$</span>' +
        '<input type="number" inputmode="decimal" min="0" max="999" step="0.01" placeholder="0.00" aria-label="Your price guess in dollars" data-pg></label>' +
        '<input type="range" min="0" max="1000" step="1" value="0" aria-label="Slide to set your guess" data-ps></div>' +
        '<div class="vgfa-row"><button type="button" class="vgfa-btn vgfa-btn--solid" data-price-go>Lock in my guess</button></div>';
    } else {
      var r = g.g[n], off = Math.abs(r.v - r.a), pct = Math.round(off / r.a * 100);
      h += '<div class="vgfa-feedback ' + (r.p >= 70 ? 'ok' : 'no') + '" role="status"><strong>Typical price: ' + money(r.a) + '</strong>' +
        '<p>You guessed ' + money(r.v) + (off < 0.005 ? ', spot on!' : ', ' + money(off) + ' ' + (r.v > r.a ? 'high' : 'low') + ' (' + pct + '%).') + ' <b>+' + r.p + ' points</b></p>' +
        (x.lo && x.hi && x.hi > x.lo ? '<p>Most stores charge about ' + money(x.lo) + ' to ' + money(x.hi) + '.</p>' : '') +
        '<p class="vgfa-small">Typical regular shelf price at ' + x.stores + ' ' + CHAIN + ' stores, ' + esc(monthLabel(x.per)) + '.</p>' +
        '<a href="/pages/check-a-price?item=' + encodeURIComponent(x.it.id) + '">Is your store\'s price a good one? Check it</a></div>' +
        '<div class="vgfa-row"><button type="button" class="vgfa-btn vgfa-btn--solid" data-price-next>' + (i >= set.length ? 'See my score' : 'Next item') + '</button></div>';
    }
    stage.innerHTML = h + '</article>';
  }

  /* ---------- Recipe Detective ---------- */
  var photoCache = {};
  function detPts(g) { return Math.max(20, 100 - 20 * (g.shown - DET_START)); }
  function drawDet() {
    var g = day().det || (day().det = { shown: DET_START, wrong: [] }), c = sets.det.c, opts = sets.det.opts, h;
    var done = !!g.done, total = c.k.length;
    h = '<article class="vgfa-game">' + head('det', "Today's case: " + esc(c.ty)) +
      '<ol class="vgfa-clues">' + c.k.map(function (k, i) {
        var show = done || i < g.shown;
        return '<li class="' + (show ? 'on' : '') + '"><span class="vgfa-cn">Clue ' + (i + 1) + '</span>' + (show ? esc(cap1(k)) : '<span class="vgfa-lock">hidden</span>') + '</li>';
      }).join('') + '</ol>';
    if (!done) {
      h += '<p class="vgfa-help">Which recipe uses these ingredients? <b>Worth ' + detPts(g) + ' points</b> right now.</p>' +
        '<div class="vgfa-choices">' + opts.map(function (t) {
          var bad = g.wrong.indexOf(t) > -1;
          return '<button type="button" class="vgfa-choice' + (bad ? ' is-wrong' : '') + '" data-det="' + esc(t) + '"' + (bad ? ' disabled aria-disabled="true"' : '') + '>' + esc(t) + '</button>';
        }).join('') + '</div>' +
        (g.shown < total ? '<div class="vgfa-row"><button type="button" class="vgfa-btn" data-det-more>Show another clue (\u221220 points)</button></div>' : '') +
        (g.wrong.length ? '<p class="vgfa-feedback no" role="status">Not that one. Here is another clue.</p>' : '');
    } else {
      h += '<div class="vgfa-feedback ' + (g.ok ? 'ok' : 'no') + '" role="status"><strong>' +
        (g.ok ? 'Case solved with ' + g.shownAt + ' clue' + (g.shownAt === 1 ? '' : 's') + '! +' + g.pts + ' points' : 'Case closed. It was this one:') + '</strong></div>' +
        '<a class="vgfa-recipe" href="/blogs/recipes/' + encodeURIComponent(c.h) + '"><span class="vgfa-recipe-img" data-recipe-img></span>' +
        '<span class="vgfa-recipe-body"><span class="vgfa-over">' + esc(c.ty) + '</span><b>' + esc(c.t) + '</b><span class="vgfa-link">Open the recipe and bake it</span></span></a>' +
        footer('det');
    }
    stage.innerHTML = h + '</article>';
    if (done) recipePhoto(c.h);
  }
  function recipePhoto(handle) {
    var box = $('[data-recipe-img]', stage);
    if (!box) return;
    function put(u) { if (u && box.isConnected) box.innerHTML = '<img src="' + esc(sized(u, 600)) + '" alt="" width="600" height="400" loading="lazy">'; }
    if (photoCache[handle] !== undefined) { put(photoCache[handle]); return; }
    fetch('/blogs/recipes/' + encodeURIComponent(handle), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var m = /<meta[^>]+property="og:image(?::secure_url)?"[^>]+content="([^"]+)"/i.exec(t || '');
      var u = m ? m[1].replace(/&amp;/g, '&') : '';
      if (u && u.indexOf('//') === 0) u = 'https:' + u;
      photoCache[handle] = u; put(u);
    }).catch(function () { photoCache[handle] = ''; });
  }

  /* ---------- sharing (never the answers) ---------- */
  function shareText(game) {
    var d = day(), lines = ['VanillaGoods Food Arcade, ' + prettyDay(today)];
    function rotLine() { var g = d.rot; return g && g.done ? 'Rot or Not? ' + g.pts + '/' + ROT_N + ' ' + g.a.map(function (x) { return x ? '\uD83D\uDFE9' : '\uD83D\uDFE5'; }).join('') : ''; }
    function priceLine() { var g = d.price; return g && g.done ? 'Grocery Price ' + g.pts + '/' + (PRICE_N * 100) : ''; }
    function detLine() { var g = d.det; return g && g.done ? 'Recipe Detective ' + (g.ok ? 'solved with ' + g.shownAt + ' clues' : 'stumped me today') : ''; }
    var map = { rot: rotLine, price: priceLine, det: detLine };
    (game === 'all' ? ORDER : [game]).forEach(function (k) { var l = map[k](); if (l) lines.push(l); });
    var s = streak();
    if (s > 1) lines.push(s + '-day streak');
    return lines.join('\n');
  }
  function share(game, btn) {
    var url = location.origin + PAGE + '?utm_source=share&utm_medium=food_arcade&utm_campaign=' + (game === 'all' ? 'daily' : game);
    var text = shareText(game);
    function said(t) { var o = btn.textContent; btn.textContent = t; setTimeout(function () { btn.textContent = o; }, 2200); }
    if (navigator.share) {
      navigator.share({ title: 'The Food Arcade', text: text, url: url }).catch(function () { /* closed */ });
      return;
    }
    var all = text + '\n' + url;
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(all).then(function () { said('Copied to clipboard'); }, function () { said('Copy failed'); });
    else {
      var ta = document.createElement('textarea'); ta.value = all; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); said('Copied to clipboard'); } catch (e) { said('Copy failed'); }
      document.body.removeChild(ta);
    }
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    var g;
    if (t.hasAttribute('data-open')) { open(t.getAttribute('data-open'), true); return; }
    if (t.hasAttribute('data-go')) { open(t.getAttribute('data-go'), true); return; }
    if (t.hasAttribute('data-share')) { share(t.getAttribute('data-share'), t); return; }
    if (t.hasAttribute('data-rot')) {
      g = day().rot; var x = sets.rot[g.a.length];
      if (!x) return;
      if (!g.t) g.t = [];
      g.t[g.a.length] = t.getAttribute('data-rot');
      g.a.push(t.getAttribute('data-rot') === 'hot');
      save(); drawRot(true); drawBoard(); return;
    }
    if (t.hasAttribute('data-rot-next')) { drawRot(); drawBoard(); return; }
    if (t.hasAttribute('data-price-go')) {
      g = day().price; var item = sets.price[g.g.length], inp = $('[data-pg]', stage), v = parseFloat(inp && inp.value);
      if (!item) return;
      if (!(v > 0)) { inp.focus(); return; }
      v = Math.round(v * 100) / 100;
      g.g.push({ v: v, a: item.a, p: pricePts(v, item.a) });
      save(); drawPrice(true); drawBoard(); return;
    }
    if (t.hasAttribute('data-price-next')) { drawPrice(); drawBoard(); return; }
    if (t.hasAttribute('data-det-more')) {
      g = day().det; if (g.shown < sets.det.c.k.length) g.shown++;
      save(); drawDet(); drawBoard(); return;
    }
    if (t.hasAttribute('data-det')) {
      g = day().det; var pickT = t.getAttribute('data-det'), c = sets.det.c;
      if (pickT === c.t) { g.ok = 1; g.shownAt = g.shown; finish('det', detPts(g)); }
      else {
        g.wrong.push(pickT);
        if (g.shown < c.k.length) g.shown++;
        if (g.wrong.length >= sets.det.opts.length - 1) { g.ok = 0; g.shownAt = g.shown; finish('det', 0); }
      }
      save(); drawDet(); drawBoard(); return;
    }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-ps')) { var v = fromSlider(+t.value); var inp = $('[data-pg]', stage); if (inp) inp.value = v.toFixed(2); }
    if (t.hasAttribute('data-pg')) { var s = $('[data-ps]', stage); var n = parseFloat(t.value); if (s && n >= 0) s.value = toSlider(n); }
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.hasAttribute && e.target.hasAttribute('data-pg')) { var b = $('[data-price-go]', stage); if (b) b.click(); }
  });

  /* ---------- reset countdown ---------- */
  function tick() {
    var now = Date.now(), k = azKey(now), el = $('[data-reset]');
    if (k !== today && today) { el.innerHTML = 'New games are ready. <a href="' + PAGE + '">Load today\'s set</a>'; return; }
    var next = new Date(now); next.setUTCHours(7, 0, 0, 0); if (next.getTime() <= now) next = new Date(next.getTime() + 864e5);
    var mins = Math.max(1, Math.round((next.getTime() - now) / 6e4)), hh = Math.floor(mins / 60), mm = mins % 60;
    var local = next.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    el.textContent = 'New games in ' + (hh ? hh + ' h ' : '') + mm + ' min (midnight Arizona time, ' + local + ' your time).';
  }

  /* ---------- start ---------- */
  S = load();
  var summary = getJSON(root.getAttribute('data-summary')).catch(function () { return null; });
  Promise.all([getJSON(root.getAttribute('data-data')), loadFresh(root.getAttribute('data-fresh'))]).then(function (res) {
    D = res[0]; FRESH = res[1];
    today = azKey(Date.now());
    dayN = Math.max(0, Math.round((Date.parse(today + 'T00:00:00Z') - Date.parse((D.epoch || today) + 'T00:00:00Z')) / 864e5));
    buildSets();
    tick(); setInterval(tick, 30000);
    var want = (location.hash || '').replace('#', '');
    open(ORDER.indexOf(want) > -1 ? want : (nextGame() || 'rot'), ORDER.indexOf(want) > -1);
    window.addEventListener('hashchange', function () {   // header / homepage links like #price while already here
      var h = (location.hash || '').replace('#', '');
      if (ORDER.indexOf(h) > -1) open(h, true);
    });
    summary.then(function (sm) {
      if (sm) { P = indexPrices(sm); buildPrice(); } else P.failed = 1;
      if (active === 'price') open('price');
    });
  }).catch(function () {
    stage.innerHTML = '<p class="vgfa-loading">Today\'s games could not load. Please refresh the page.</p>';
  });
})();
